var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /Users/sandersturing/Sites/EXT/kd/frontend/node_modules/babel-polyfill/node_modules/core-js/modules/_html.js
// module id = 67
// module chunks = 0